import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbOptionModule, NbSelectModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { SelectInput } from './../../../models/inputs/select-input';
import { AddClearOptionPipe } from './../../../pipes/add-clear-option.pipe';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-select-input',
	template: `
		<ng-container
			[ngTemplateOutlet]="control.compareWith ? custom : default"
		></ng-container>

		<ng-template #default>
			<nb-select
				[attr.id]="controlId"
				fullWidth
				size="medium"
				[status]="control.colorStatus"
				[multiple]="control.multiple"
				[formControl]="control"
				[placeholder]="control.placeholder | translate"
			>
				@for (
					option of control.options
						| async
						| addClearOption: control.clearable;
					track option
				) {
					<nb-option [value]="option.value">{{
						option.label | translate
					}}</nb-option>
				}
			</nb-select>
		</ng-template>

		<ng-template #custom>
			<nb-select
				[attr.id]="controlId"
				fullWidth
				[compareWith]="control.compareWith"
				size="medium"
				[status]="control.colorStatus"
				[multiple]="control.multiple"
				[formControl]="control"
				[placeholder]="control.placeholder | translate"
			>
				@for (
					option of control.options
						| async
						| addClearOption: control.clearable;
					track option
				) {
					<nb-option [value]="option.value">{{
						option.label | translate
					}}</nb-option>
				}
			</nb-select>
		</ng-template>
	`,
	standalone: true,
	imports: [
		NgTemplateOutlet,
		NbSelectModule,
		ReactiveFormsModule,
		NbOptionModule,
		AsyncPipe,
		TranslateModule,
		AddClearOptionPipe
	]
})
export class SelectInputComponent extends BaseInputComponent {
	@Input({ required: true }) override control: SelectInput;
}
